import { Update } from "@ngrx/entity";
import { createAction, props } from "@ngrx/store";
import { Step, StepId } from "src/app/interfaces";

/*
export const loadSteps = createAction(
  "[Step] Load Steps",
  props<{ steps: Step[] }>()
);
*/

export const addStep = createAction("[Step] Add Step", props<{ step: Step }>());

export const upsertStep = createAction(
  "[Step] Upsert Step",
  props<{ step: Step }>()
);

export const addSteps = createAction(
  "[Step] Add Steps",
  props<{ steps: Step[] }>()
);

export const upsertSteps = createAction(
  "[Step] Upsert Steps",
  props<{ steps: Step[] }>()
);

export const updateStep = createAction(
  "[Step] Update Step",
  props<{ step: Update<Step> }>()
);

export const updateSteps = createAction(
  "[Step] Update Steps",
  props<{ steps: Update<Step>[] }>()
);

export const deleteStep = createAction(
  "[Step] Delete Step",
  props<{ id: StepId }>()
);

export const deleteSteps = createAction(
  "[Step] Delete Steps",
  props<{ ids: StepId[] }>()
);

export const clearSteps = createAction("[Step] Clear Steps");
